export const BackendUrls = {
    url: (path: string) => process.env.REACT_APP_BACKEND_URL+path,
    companies: () => BackendUrls.url("/companies"),
    companiesId: (id: string) => BackendUrls.url("/companies/"+id),
}
